import type { MouseEvent, ReactNode } from 'react'

interface Props {
  asSheet: boolean
  onClose: () => void
  variant?: 'device' | 'overview'
  children: ReactNode
}

export function PanelShell({ asSheet, onClose, variant, children }: Props) {
  if (!asSheet) return <>{children}</>
  const onBackdrop = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }
  return (
    <div className="modal-overlay modal-overlay--sheet" onClick={onBackdrop}>
      <div className={`modal modal--sheet dpanel-sheet ${variant === 'overview' ? 'dpanel-sheet--overview' : ''}`}>
        <div className="modal__grabber" aria-hidden="true" />
        {children}
      </div>
    </div>
  )
}
